import moment from 'moment-timezone';
import { GymTimeZone } from '../gym';

export class TimeZoneMapping {
  public static formattedLocalTimeToDate(localTime: string, localTimeZone: string): Date {
    return moment.tz(localTime, 'YYYY-MM-DD HH:mm:ss', localTimeZone).toDate();
  }

  public static dateToFormattedLocalTimeWithoutTimezone(date: Date, localTimeZone: string): string {
    return TimeZoneMapping.dateToFormattedLocalTime(date, localTimeZone, 'YYYY-MM-DDTHH:mm:ss');
  }

  public static dateToFormattedLocalTime(date: Date, localTimeZone: string, format: string): string {
    return moment(date)
      .tz(localTimeZone)
      .format(format);
  }

  public static dateInTimezoneToUTCDate(yyyymmdd: string, timezone: string): Date {
    return moment.tz(yyyymmdd, 'YYYYMMDD', timezone).utc().toDate();
  }

  public static getEndOfDayInTimezone(yyyymmdd: string, timezone: string): Date {
    return moment.tz(yyyymmdd, 'YYYYMMDD', timezone).endOf('day').utc().toDate();
  }

  /**
   * Get the day of week. Comparable to `Date.getDay()`, but for a given time zone
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay
   * @returns 0 (Sunday) to 6 (Saturday)
   */
  public static getDayOfWeekNumber(date: Date, localTimeZone: string): number {
    return moment(date).tz(localTimeZone).day();
  }

  public static getSystemTimeZoneName(): GymTimeZone {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    if (timeZone) {
      return timeZone as GymTimeZone;
    }
    return moment.tz.guess() as GymTimeZone;
  }
}
